import useDeleteApi from './useDeleteApi';
import { url } from '../../utils/confserveur';
export const useDeleteEvalNat = () => {
  const { deleteData } = useDeleteApi();

  // Rend { success, data, error } : l'écran sait si le serveur a supprimé, et sinon pourquoi.
  // Avec une classe (page d'une classe) : seuls les résultats nationaux des élèves de cette classe partent ; la
  // campagne du niveau, les autres classes et les bilans restent (plan du 30/10/2026, étape 4). Sans classe : un
  // bilan ou une évaluation antérieure, par son seul numéro.
  const deleteEvaluationNat = (evalId, classeId) =>
    deleteData(`${url}evaluations_nat/${evalId}/${classeId ? `?classe=${classeId}` : ''}`);

  return { deleteEvaluationNat };
};
